module.exports = "/images/b5a0f0f4dcab8f23a979f7aeb79389c8.jpg";